import type { TRecommendation } from '../../types/recommendation';

type TRecommendationWithAnalytics = Pick<TRecommendation, 'analyticsData'>;

export function getAdjacentTrapPositionInTwoColumnGrid(
  recommendations: readonly TRecommendationWithAnalytics[],
  index: number,
): number | undefined {
  if (recommendations[index]?.analyticsData.type !== 'offer') {
    return undefined;
  }

  const adjacentIndex = index % 2 === 0 ? index + 1 : index - 1;

  return recommendations[adjacentIndex]?.analyticsData.type === 'trap' ? adjacentIndex + 1 : undefined;
}
